import React from "react";
import { motion } from "framer-motion";
import freshstartImage from "./Images/vocaboost2.jpg";
import {
  Container,
  Typography,
  Box,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemText,
  Grid,
} from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import Nav from "../../../Nav";

const VocaBoost = () => {
  return (
    <>
      <motion.div
        className="p-5 font-sans bg-gray-100 h-4/5 mt-20"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        {/* Page Title */}
        <h1 className="text-4xl font-extrabold text-gray-600 text-center mb-8">
          Dictation Course
        </h1>

      
      </motion.div>
      <Nav />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Box
          sx={{
            backgroundColor: "#f8fafc",
            py: 5,
            fontFamily: "Arial, sans-serif",
          }}
        >
          <Box
            sx={{
              backgroundImage: `url(${freshstartImage})`,
              backgroundSize: "cover",
              py: 10,
              textAlign: "center",
              color: "#fff",
            }}
          >
            <Container maxWidth="lg">
              <Typography
                variant="h1"
                align="center"
                gutterBottom
                sx={{
                  fontWeight: "bold",
                  fontFamily: "Arial, sans-serif",
                  color: "#fff",
                }}
              >
                VocaBoost
              </Typography>
            </Container>
          </Box>

          <Container
            maxWidth="lg"
            sx={{
              backgroundColor: "#ffffff",
              p: 5,
              borderRadius: 2,
              boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              mt: -8,
            }}
          >
            <Grid container spacing={5} alignItems="flex-start" mb={10}>
              <Grid item xs={12} lg={6}>
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{
                    fontFamily: "Arial, sans-serif",
                    fontWeight: "bold",
                    color: "#172b4d",
                  }}
                >
                  <i>Coming Soon!</i>
                </Typography>
              </Grid>
              <Grid item xs={12} lg={6}>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <CardMedia
                    component="img"
                    image={freshstartImage}
                    alt="Fresh Start"
                    sx={{
                      borderRadius: 2,
                      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                    }}
                  />
                </motion.div>
              </Grid>
            </Grid>
            <div className="flex flex-col md:flex-row gap-6 items-center justify-center">
          {/* Card 1: Course Details */}
          <div className="w-full md:w-1/2 bg-green-100 shadow-lg rounded-lg p-6">
            <p className="text-gray-700 mb-2">
              <strong>Type of course:</strong> Self studying course
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Number of lessons:</strong> 20 PDF lessons with phrasal
              verbs and 20 PDF lessons with idioms.
            </p>
            <p className="text-gray-700 mb-2">
              <strong>Price:</strong> $360 (paid $ 30 monthly) or $ 290
              annually.
            </p>
          </div>

          {/* Card 2: Bundle Pricing */}
          <div className="w-full md:w-1/2 bg-blue-100 shadow-lg rounded-lg p-6">
            <h2 className="text-2xl font-bold text-gray-800 text-center mb-4">
              Bundle Price Option
            </h2>
            <p className="text-gray-700 mb-4 text-center">
              <strong>Bundle Price:</strong>$ 0 / 1 year access / Value: $ 290
            </p>
          </div>
        </div>
            <Box textAlign="center" mb={10} mt={2}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                sx={{ borderRadius: 5, px: 5, py: 2 }}
              >
                Join Now
              </Button>
            </Box>
          </Container>
        </Box>
      </motion.div>
    </>
  );
};

export default VocaBoost;
